import { useRoutes } from 'react-router-dom';
import { AboutUs, ContactUs, Gallery, Landing, Services } from 'features/misc';
import { publicRoutes } from './public';

export const AppRoutes = () => {
  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/about', element: <AboutUs /> },
    { path: '/services', element: <Services /> },
    { path: '/gallery', element: <Gallery /> },
    { path: '/contact', element: <ContactUs /> },
  ];

  const routes = publicRoutes;

  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
